import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CataloghiComponent } from './cataloghi.component';
import { CataloghiCreateComponent } from './cataloghi-create/cataloghi-create.component';
import { CataloghiComboComponent } from './cataloghi-combo/cataloghi-combo.component';
import { CataloghiDetailsComponent } from './cataloghi-details/cataloghi-details.component';
import { CataloghiEditComponent } from './cataloghi-edit/cataloghi-edit.component';
import { CataloghiListComponent } from './cataloghi-list/cataloghi-list.component';

const routes: Routes = [

    {
        path: '', component: CataloghiComponent, children:
        [
            { path: 'create', component:CataloghiCreateComponent},
            { path: '',component:CataloghiListComponent},
            {path: 'edit/:id',component:CataloghiEditComponent},
             { path: 'details/:id',component:CataloghiDetailsComponent},
             { path: 'combo', component:CataloghiComboComponent}
        ]
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CataloghiRoutingModule { }
